// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminCmEvaluationListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(evaluationId) {
    const { match } = this.props; 
    this.props.history.push(`/admin/authoring/evaluations/${evaluationId}`);
  }

  render() {
    const { evaluation } = this.props;
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, evaluation._id)}>
        <td className="_40">{evaluation.title}</td>
        <td className="_20">{evaluation.status}</td>
        <td className="_20">{moment(evaluation.updated).format("MMMM Do YYYY, h:mm a")}</td>
      </tr>
    )
  }
}

AdminCmEvaluationListItem.propTypes = {
  evaluation: PropTypes.object.isRequired
}

export default withRouter(AdminCmEvaluationListItem);



// WEBPACK FOOTER //
// modules/evaluation/components/AdminCmEvaluationListItem.js.jsx